<template>
  <div>
    <naj-box
      :title="local.lawsuitDetails.terminationsRequest.subTitle"
      :collapsed="false"
    >
      <v-row>
        <v-col cols="10">
          <h3 class="sec-header">
            {{ local.lawsuitDetails.terminationsRequest.addConcerned }}
            <template>
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon
                    class="tooltip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-exclamation
                  </v-icon>
                </template>
                <div style="white-space: pre-line;   max-width: 250px;">
                  <span>{{ local.lawsuitDetails.terminationsRequest.tooltipHeader }}</span><br>
                  <span> {{ local.lawsuitDetails.terminationsRequest.tooltip }}</span>
                </div>
              </v-tooltip>
            </template>
          </h3>
        </v-col>
      </v-row>

      <naj-data-table
        :headers="tableColumns"
        :items="formModel.minorConcernedList"
        :server-items-length="(formModel .minorConcernedList || []).length"
        :pagination="true"
      >
        <template slot-scope="{ item }">
          <v-btn
            v-if="!isViewMode && !mode.isViewMode"
            icon
            @click="selectItem(item)"
          >
            <v-icon>
              mdi-lead-pencil
            </v-icon>
          </v-btn>
          <v-btn
            icon
            @click="selectViewItem(item)"
          >
            <v-icon>
              mdi-eye
            </v-icon>
          </v-btn>
          <v-btn
            v-if="!isViewMode && !mode.isViewMode"
            icon
            @click="openRemovePopup(item.objectKey)"
          >
            <v-icon color="red">
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
      </naj-data-table>
      <v-row v-if="!isViewMode && !mode.isViewMode">
        <v-col
          cols="1"
          class="mb-6"
        >
          <naj-button
            icon="mdi-plus"
            @click="openAddModal"
          >
          </naj-button>
        </v-col>
      </v-row>
      <v-row>
        <add-concerned-of-minor-modal
          ref="AddConcernedOfMinorModal"
          :show-modal="showModal"
          :selected-item="selectedItem"
          :view-mode="viewMode"
          @addItem="AddConcernedOfMinor"
          @updateItem="updateMinorConcernedListObject"
          @deleteItem="openRemovePopup"
          @onClose="modalClosed"
        ></add-concerned-of-minor-modal>
      </v-row>
      <naj-confirmation
        :show-modal="showRemovePopup"
        color="error"
        :title="local.common.removeConfirmation"
        :message="local.common.removeConfirmationMessage"
        :ok-btn-label="local.common.remove"
        @ok="removeConfirmed"
        @cancel="closeRemovePopup"
      ></naj-confirmation>
      <naj-input
        class="danger-input"
        :type-id="formFieldType.checkbox"
        :value.sync="formModel.minorConcernedDisclaimer"
        :label="local.lawsuitDetails.terminationsRequest.promise"
        validates="required"
        :disabled="isViewMode || mode.isViewMode"
        @change="updateMinorConcernedDisclaimer()"
      ></naj-input>
    </naj-box>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import AddConcernedOfMinorModal from './add-concerned-of-minor-modal.vue';
import { uuidGenerator } from '@/helpers/utils';
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('LawsuitModule');
export default {
  inject: ['mode', '$validator'],
  components: { AddConcernedOfMinorModal },
  props: {
    formModel: { type: Object },
    isViewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      showModal: false,
      showRemovePopup: false,
      selectedItem: null,
      viewMode: false,
      tableColumns: [
        {
          value: 'fullname',
          text: 'الاسم بالكامل',
        },
        {
          value: 'socialId',
          text: 'رقم الهوية',
        },
        {
          value: 'dateOfBirth',
          text: 'تاريخ الميلاد',
        },
        {
          text: '',
          value: 'action',
        },
      ],
    };
  },
  computed: {
    isViewMode() { return false; },
    ...mapState({ auditFields: state => state.lawsuitRequest.auditFields }),
    ...mapGetters(['isAuditFieldsDisabled']),
  },
  mounted() {
    this.$set(this.formModel, 'minorConcernedList', this.formModel.minorConcernedList || []);
    if (this.formModel.minorConcernedList) {
      for (let i = 0; i < this.formModel.minorConcernedList.length; i++) {
        let element = this.formModel.minorConcernedList[i];
        let fullname = `${element.firstName ? element.firstName + ' ' : ''}${element.fatherName ?
          element.fatherName + ' ' : ''}${element.grandFatherName ? element.grandFatherName + ' ' : ''}${element.familyName ? element.familyName : ''}`;
        this.$set(this.formModel.minorConcernedList[i], 'fullname', fullname);
      }
    }
  },
  methods: {
    ...mapActions(['updateAuditFields']),
    openAddModal() {
      this.showModal = true;
    },
    selectItem(item) {
      this.selectedItem = item;
      this.showModal = true;
    },
    selectViewItem(item) {
      this.selectedItem = item;
      this.viewMode = true;
      this.showModal = true;
    },
    closeAddRecordModal() {
      this.showModal = false;
    },
    openRemovePopup(objectKey) {
      this.objectKeyToRemove = objectKey;
      this.showRemovePopup = true;
    },
    removeConfirmed() {
      this.formModel.minorConcernedList = this.formModel.minorConcernedList.filter(
        item => item.objectKey != this.objectKeyToRemove
      );
      this.closeAddRecordModal();
      this.showRemovePopup = false;
      this.$set(this.formModel, 'caseHasChanges', true);
    },
    closeRemovePopup() {
      this.objectKeyToRemove = null;
      this.showRemovePopup = false;
    },
    AddConcernedOfMinor(data) {
      this.formModel.minorConcernedList = this.formModel.minorConcernedList.concat({
        ...data,
        objectKey: uuidGenerator(),
      });
      this.$set(this.formModel, 'caseHasChanges', true);
    },
    modalClosed() {
      this.selectedItem = null;
      this.viewMode = false;
      this.showModal = false;
    },
    updateMinorConcernedListObject(data) {
      const rowIndex = (this.formModel.minorConcernedList || []).indexOf(this.selectedItem);
      this.$set(this.formModel.minorConcernedList, rowIndex, data);
      this.$set(this.formModel, 'caseHasChanges', true);
    },
    updateMinorConcernedDisclaimer() {
      this.$set(this.formModel, 'caseHasChanges', true);
      if (!this.formModel.minorConcernedDisclaimer) {
        this.$set(this.formModel, 'minorConcernedDisclaimer', null);
      }
    },
  },
};
</script>
<style scoped>
.sec-header {
  padding-bottom: 20px;
  display: flex;
}
.tooltip {
  border: 1px solid gray;
  border-radius: 50px;
  border: 1px solid grey;
  border-radius: 50px;
  display: block;
  opacity: 100;
  height: 20px;
  font-size: 18px;
  margin-right: 2px;
  margin-top: auto;
  z-index: 1;
}
</style>